<!--child.vue-->
<template>
  <div class="tips_wrap">
    <el-dialog
      :close-on-click-modal="false"
      title=""
      :visible.sync="dialogFormVisible"
      @close="closeDialog"
    >
      <div slot="title" class="header-title">
        <span class="title-name">{{ title }}</span>
      </div>
      <el-form
        v-loading="loading"
        :model="ruleForm"
        ref="ruleForm"
        label-width="50rpx"
        :inline="true"
        class="demo-ruleForm"
      >
        <el-form-item label="姓名">
          <el-input v-model="ruleForm.customName" :disabled="info"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="ruleForm.customPhone" :disabled="info"></el-input>
        </el-form-item>

        <el-form-item label="余额">
          <el-input v-model="ruleForm.customMoney" :disabled="info"></el-input>
        </el-form-item>

        <el-form-item label="历史记录" v-if="info">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="createTime" label="日期" width="180">
            </el-table-column>
            <el-table-column prop="remake" label="备注" width="180">
            </el-table-column>
            <el-table-column prop="chargeMoney" label="变动金额" width="180">
            </el-table-column>

            <el-table-column prop="remainingAmount" label="当前剩余">
            </el-table-column>
          </el-table>
        </el-form-item>

        <el-form-item v-if="!info">
          <div style="text-align: right">
            <el-button type="primary" @click="submitForm()">保存</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    console.log("我是子组件");
  },

  data() {
    return {
      tableData: [],
      title: "新增会员",
      info: false,
      loading: false,
      ruleForm: {
        id: "",
        cusomeName: "",
        cusomePhone: "",
        cusomeMoney: "",
      },
      dialogFormVisible: this.dialogShow,
    };
  },
  created() {},
  watch: {
    dialogShow(val) {
      this.dialogFormVisible = val;
    },
  },
  methods: {
    init(id) {
      if (id) {
        this.info = true;
        this.title = "会员信息";
      }

      var that = this;
      that.loading = true;
      this.$axios
        .get("/api2/business/getCustomInfo/" + id, {})
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            console.log(response.data.data);
            that.ruleForm = response.data.data;
            that.tableData = response.data.data.rechargeRecordList;
          } else {
            that.$message.error(response.mes);
          }
          that.loading = false;
        });
    },
    submitForm() {
      var that = this;

      this.$axios
        .post("/api2/business/addCustom", that.ruleForm)
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.$message({
              type: "success",
              message: "操作成功",
            });
            that.$emit("pushdata");
            that.closeDialog();
          } else {
            that.$message.error(response.data.mes);
          }
        });
    },

    closeDialog() {
      this.$emit("modelChange", false);
    },
  },
};
</script>

